import Vue from 'vue';
import Component from "vue-class-component";
import ABaseComponent from "Components/Base/ABaseComponent";
import { Prop } from "vue-property-decorator";
import porterBuilder from 'Store/porterbuilder/porterbuilder';
import { GetPorterItemListViewModel, PorterItemViewModel } from 'Api/CoreApi';
import { ProductViewModel } from "Api/CoreApi";
import productVariantStore from "Store/productVariantStore/productVariantStore";
import { ProductListPage, ProductWithSpecification, Pagination, Product } from "Models/Products/ProductListPage";

@Component({})
export class PDPComponent extends ABaseComponent {
    porterItems: GetPorterItemListViewModel = null;

    @Prop({ default: 'LANG1' })
    public languageId: string;

    @Prop({ default: '' })
    public productId: string;

    public modalId: string = "";

    async created() {
        await porterBuilder.dispatchInitializePorter();

        porterBuilder.dispatchLoadPorterItems(this.languageId).then((items) => {
            this.setLoaded();
        }).catch(e => this.setError(e));

        this.getPorterModalId();
    }

    public getPorterListItem(number: string): PorterItemViewModel {
        return porterBuilder.state.porterItems.porterItems.find(x => x.porterItem.itemNo == number) || null;
    }

    public async getPorterModalId() {
        await productVariantStore.loadVariantCount({
            languageId: this.languageId,
            productId: this.productId
        });

        var variantNumber = await productVariantStore.getModalId(this.productId);
        this.modalId = "add-to-porter-box-" + variantNumber;
    }

    get porterBuilderModeActive() {
        return porterBuilder.state.porterId ? true : false;
    }
    public allowAddToPorter(itemNo: string, isSelectionOldModel: boolean) {

        let porterListItem = this.getPorterListItem(itemNo);
        if (porterListItem && porterBuilder.state.porterItems.porterItems && porterListItem.porterItem.isOldModelSales) {
            return false;
        } else if (!porterListItem && isSelectionOldModel) {

            return false;
        }
        return true;
    }

}
Vue.component("pdp", PDPComponent);